export const hex = (value) => /^[0-9a-f]+$/i.test(value);
